module.exports = __webpack_public_path__ + "static/media/fb.c30989b9.svg";